// Copyright (c) 2024 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { api } from '@/api/axios-instance';
import { parseResponse } from '@/api/parse-response';
import { auditEventsResponseSchema } from '@/audit/api/types';

/**
 * Fetches audit events for a specific cost
 *
 * @param costKey - The unique key of the cost
 * @returns A promise that resolves to the audit events for the cost
 */
export async function getCostAuditEvents(costKey: string) {
  const url = `/v1/cost/${costKey}/audit`;
  const response = await api.get(url);

  return await parseResponse(auditEventsResponseSchema, response.data, {
    schemaName: 'CostAuditEvents',
    endpoint: url,
  });
}
